import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import companyRoutes from './companies/routes';
import { routes as kanbanRoutes } from './kanban/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';

const AppContainer = () => import('./Dashboard.vue');
const Suspended = () => import('./suspended/Index.vue');
const ToolzzChatConsent = () => import('../../views/ToolzzChatConsent.vue');

export default {
  routes: [
    {
      path: '/pagina-chat',
      name: 'toolzz_chat_consent',
      component: ToolzzChatConsent,
      meta: {
        permissions: ['administrator'],
      },
    },
    ...helpcenterRoutes.routes,
    {
      path: frontendURL('accounts/:account_id'),
      component: AppContainer,
      children: [
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes.routes,
        ...kanbanRoutes,
        ...searchRoutes,
        ...notificationRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator',
        'agent',
        'control',
        'monitoring',
        'coordination',],
      },
      component: Suspended,
    },
  ],
};
